import { TitleProps } from '@picsart/growth-rc/Title';
import { ColorsEnum } from './constants';

export enum SocialMediaIcons {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  YouTube = 'YouTube',
  Twitter = 'Twitter',
  LinkedIn = 'LinkedIn',
  Twitch = 'Twitch',
  Pinterest = 'Pinterest',
  TikTok = 'TikTok',
  SnapChat = 'SnapChat',
  Spotify = 'Spotify',
}
export interface Image {
  src: string;
  alt: string;
}

interface Media {
  icon: SocialMediaIcons;
  image: Image;
  color: ColorsEnum;
}

export interface BannerItem {
  media: Media;
  title: string;
  redirectUrl: string;
}

export interface ShowAll {
  title: string;
  redirectUrl: string;
}

export interface TemplateBannerCarouselProps {
  bannerItems: Array<BannerItem>;
  title: TitleProps;
  showAll?: ShowAll;
}
